import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { HotSearchTranslationFragment } from "@saleor/fragments/types/HotSearchTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsHotWordPageProps
  extends TranslationsEntitiesPageProps {
  hotWord: HotSearchTranslationFragment;
}

export const fieldNames = {
  hotWord: "hotWord"
};

const TranslationsHotWordPage: React.FC<TranslationsHotWordPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  hotWord,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Hot Word "{hotWordName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            hotWordName: maybe(() => hotWord.hotWord, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Hot Word"
            }),
            name: fieldNames.hotWord,
            translation: maybe(() =>
              hotWord.translation ? hotWord.translation.hotWord : null
            ),
            type: "short" as "short",
            value: maybe(() => hotWord.hotWord)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsHotWordPage.displayName = "TranslationsHotWordPage";
export default TranslationsHotWordPage;
